import React, { useEffect, useRef, useState } from "react";
import Table from "../../components/Table/Table";
import NewTable from "../../components/Table/NewTable";
import "./MyProposals.css";
import Pagination from "../../components/Pagination/Pagination";
import PopUp from "../../components/PopUp/PopUp";
import Button from "../../components/Button/Button";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
//import { Globals } from "../../global/Globals";
import Search from "../../components/SearchBar/Search";
import { deleteSolicitedProposalById, deleteUnsolicitedProposalById, fetch_Proposals, fetchmyProposals, ProposolsCount } from "../../services/dashboardAPI";
import { fetchByfilter } from "../../services/GenericAPI";
import { useNavigate } from "react-router-dom";
import NoResultsComponent from "../../components/NoResults/NoResult";
import { use } from "react";
import Loader from "../../components/Loader/Loader";
import Toast from "../../components/Toast/Toast";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../../context/Languagecontext";
import FallBackLabel from '../../global/Globals_Eng.json';

let paginationPageChange = () => { };
const MyProposals = () => {
  const navigate = useNavigate();
  const { Globals, languages, setLanguages } = useLanguage();
  const [proposalsData, setproposalsData] = useState(null);
  const [propsalsCount, setProposalsCount] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [enableClearAll, setEnableClearAll] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  const [proposalsDatastatus, setproposalsDatastatus] = useState(null);
  const [dataSorting, setDatasorting] = useState(1);
  const location = useLocation();
  const [successToast, setSuccessToast] = useState({ status: false, title: Globals.PROPOSAL_SUBMIT_SUCCESS });
  const [deletePopup, setDeletePopup] = useState({ open: false });
  const [loadingState, setLoadingState] = useState(false);
  const { success, draft, discard, user } = location.state || {};

  useEffect(() => {
    if (success) {
      if (draft) {
        setSuccessToast({ status: true, title: Globals.PROPOSAL_SAVE_SUCCESS });
      } else if (discard) {
        setSuccessToast({ status: true, title: Globals.TOAST_DISCARD_PROPOSAL_PROMPT_TITLE });
      }
      else if (user) {
        setSuccessToast({ status: true, title: Globals.PROPOSAL_SUBMIT_SUCCESS_PRODUCER });
      }
      else {
        setSuccessToast({ status: true, title: Globals.PROPOSAL_SUBMIT_SUCCESS });
      }
      setTimeout(() => {
        setSuccessToast({ status: false, title: "" });
      }, 4000);
    }
  }, [success]);

  const prevSelectedState = useRef({});

  const [dropdownState, setDropdownState] = useState({
    activeDropdown: null,
    dropdowns: {
      CHANNEL: { options: [], selected: [], selectedText: [], isloading: false },
      TYPE: { options: [], selected: [], selectedText: [], isloading: false },
      DATE: {
        selected: [],
        selectedMonthYear: [],
        selectedText: [],
        isDatePicker: true,
        isloading: false,
      },
      STATUS: { options: [], selected: [], selectedText: [], isloading: false },
    },
  });

  const dropdownRefs = useRef({}); // Store refs for dropdowns

  const handleRowClick = (item) => {
    setSelectedItem(item);
  };

  const onPageChange = (pageNumber, setPage = () => { }) => {
    setCurrentPage(pageNumber);
    paginationPageChange = setPage;
  };

  const fetchmyProposals = async (type, date) => {
    try {
      const response = await fetch_Proposals(type, date);
      setproposalsData(response.data.content.proposals);
      setProposalsCount(response.data.content.totalPageCount);
      setproposalsDatastatus(response.data.status);
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  };

  useEffect(() => {
    let hasChanges = false;
    const hasSelectedOptions = Object.values(dropdownState?.dropdowns).some(
      (dropdown) => dropdown?.selected && dropdown?.selected.length >= 0
    );
    const hasselectedOptions = Object.values(dropdownState.dropdowns).some(
      (dropdown) => dropdown?.selected && dropdown.selected.length > 0
    );

    if (hasselectedOptions) {
      setEnableClearAll(true);
    } else {
      setEnableClearAll(false);
    }

    Object.keys(dropdownState.dropdowns).forEach((key) => {
      const currentSelected = dropdownState.dropdowns[key]?.selected;
      const prevSelected = prevSelectedState.current[key]?.selected;

      if (JSON.stringify(currentSelected) !== JSON.stringify(prevSelected)) {
        hasChanges = true;

        if (hasSelectedOptions) {
          const MyProposalsdata = {
            channel: dropdownState.dropdowns.CHANNEL.selected,
            proposalType: dropdownState.dropdowns.TYPE.selected,
            proposalStatus: dropdownState.dropdowns.STATUS.selected,
            applicationDate:
              dropdownState.dropdowns.DATE.selected.length > 0
                ? dropdownState.dropdowns.DATE.selected
                : "string",
            search: searchQuery ? searchQuery : "",
            filter: dataSorting,
          };
          paginationPageChange(1);
          fetchmyProposals(MyProposalsdata, 1);
        }
      }
    });

    if (hasChanges) {
      prevSelectedState.current = { ...dropdownState.dropdowns };
    }
  }, [dropdownState]);

  useEffect(() => {
    const MyProposalsdata = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      proposalType: dropdownState.dropdowns.TYPE.selected,
      proposalStatus: dropdownState.dropdowns.STATUS.selected,
      applicationDate:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    fetchmyProposals(MyProposalsdata, currentPage);
  }, [currentPage]);

  useEffect(() => {
    const MyProposalsdata = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      proposalType: dropdownState.dropdowns.TYPE.selected,
      proposalStatus: dropdownState.dropdowns.STATUS.selected,
      applicationDate:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    paginationPageChange(1);
    fetchmyProposals(MyProposalsdata, 1);
  }, [searchQuery]);

  useEffect(() => {
    const MyProposalsdata = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      proposalType: dropdownState.dropdowns.TYPE.selected,
      proposalStatus: dropdownState.dropdowns.STATUS.selected,
      applicationDate:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    fetchmyProposals(MyProposalsdata, currentPage);
  }, [dataSorting]);

  const handleClickOutside = (event) => {
    // Check if the click is outside all dropdowns
    const isClickInsideDropdown = Object.values(dropdownRefs.current).some((ref) =>
      ref?.contains(event.target)
    );

    if (!isClickInsideDropdown) {
      setActiveDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const deleteUnsolicitedProposal = async (open = false, proposalId) => {
    if (open) {
      setDeletePopup({ open: true, proposalId, type: "unsolicted" });
      return;
    }
    if (proposalId) {
      try {
        const response = await deleteUnsolicitedProposalById(proposalId);
        if (response && response?.data?.status == "OK") {
          handleDeleteProposal(proposalId)
          setDeletePopup({ open: false, proposalId, success: true, title: Globals.TOAST_INFO_DELETE_MSG });
          setTimeout(() => {
            setDeletePopup({ open: false });
          }, 3000);
        }
      } catch {
        setDeletePopup({ success: true, title: Globals.FAILED_DELETE_PROPOSAL });
        setTimeout(() => {
          setDeletePopup({ open: false });
        }, 3000);
      }

    }
  }
  const handleDeleteProposal = (proposalId) => {
    const updatedData = proposalsData.filter((item) => item.proposalId !== proposalId);
    setproposalsData(updatedData);
  };
  const deleteSolicitedProposal = async (open = false, proposalId) => {
    if (open) {
      setDeletePopup({ open: true, proposalId, type: "solicted" });
      return;
    }
    if (proposalId) {
      try {
        const response = await deleteSolicitedProposalById(proposalId);
        if (response && response?.data?.status == "OK") {
          handleDeleteProposal(proposalId)
          setDeletePopup({ open: false, proposalId, success: true, title: Globals.TOAST_INFO_DELETE_MSG });
          setTimeout(() => {
            setDeletePopup({ open: false });
          }, 3000);
        }
      } catch {
        setDeletePopup({ success: true, title: Globals.FAILED_DELETE_PROPOSAL });
        setTimeout(() => {
          setDeletePopup({ open: false });
        }, 3000);
      }
    }
  }

  const RenderDeletePopup = () => {
    if (deletePopup?.open) {

      return (
        <PopUp
          title={Globals.DELETE_PROPOSAL}
          text={Globals.DELETE_UNSOLICITED_PROPOSAL_PROMPT}
          onClose={() => setDeletePopup({ open: false })}
          negativeAction={() => deletePopup?.type === 'solicted' ? deleteSolicitedProposal(false, deletePopup.proposalId || null) : deleteUnsolicitedProposal(false, deletePopup.proposalId || null)}
          negativeActionText={Globals.DELETE_PROPOSAL}
        />
      );
    } else {
      return null;
    }
  };

  const handletog = async (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));

    if (
      dropdownState.dropdowns[dropdownName]?.options &&
      dropdownState.dropdowns[dropdownName]?.options.length === 0
    ) {
      await fetchOptions(dropdownName);
    }
  };

  const fetchOptions = async (dropdownName) => {
    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: true },
      },
    }));

    try {
      const response = await fetchByfilter(FallBackLabel.FILTER_OPTIONS_NAME_MYPROPOSALS[dropdownName]);
      const data = response.data.content;
      const filterData = data[FallBackLabel.FILTER_OPTIONS_NAME_MYPROPOSALS[dropdownName]];
      // Simulate fetching options for each dropdown
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...prev.dropdowns[dropdownName],
            options: [...filterData],
            isLoading: false,
          },
        },
      }));
    } catch (error) {
      console.error("Error fetching options:", error);
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: false },
        },
      }));
    }
  };

  const handleSelectAll = (dropdownName, selectAll, options) => {
    setproposalsDatastatus(null);
    const selectedDataSting = options.map((option) => String(option.id));
    const selectedDataText = options.map((option) => String(option.name));

    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: {
          ...prev.dropdowns[dropdownName],
          selected: selectAll ? selectedDataSting : [],
          selectedText: selectAll ? selectedDataText : [],
        },
      },
    }));
  };

  const handleSelect = (dropdownName, value) => {
    setproposalsDatastatus(null);
    setDropdownState((prev) => {
      const dropdown = prev.dropdowns[dropdownName];
      if (!dropdown) return prev;
      const isSelected = dropdown.selected.includes(String(value.id));
      const inSelectedText = dropdown.selectedText.includes(String(value.name));

      const newSelected = isSelected
        ? dropdown.selected.filter((item) => item !== String(value.id)).map(String)
        : [...dropdown.selected.filter((item) => item !== String(value.id)), String(value.id)];

      const newSelectedText = inSelectedText
        ? dropdown.selectedText.filter((item) => item !== String(value.name)).map(String)
        : [
          ...dropdown.selectedText.filter((item) => item !== String(value.name)),
          String(value.name),
        ];

      return {
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...dropdown,
            selected: newSelected,
            selectedText: newSelectedText,
          },
        },
      };
    });
  };

  const handleClearAll = () => {
    if (enableClearAll) {
      setproposalsDatastatus(null);
      setCurrentPage(1);
      setEnableClearAll(false);
      setSearchQuery(null);
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [] };
          if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
            acc[key].selectedMonthYear = [];
          }
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
    }
  };

  const handleDateChange = (dropdownName, date) => {
    setproposalsDatastatus(null);
    if (date instanceof Date && !isNaN(date)) {
      const month = date.getMonth() + 1; // Months are 0-based
      const year = date.getFullYear();

      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const MonthName = monthNames[month - 1];

      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...prev.dropdowns[dropdownName],
            selected: month + "-" + year,
            selectedMonthYear: month + "," + year,
            selectedText: MonthName + "-" + year,
          },
        },
      }));
    }
  };

  const handleSearch = (term) => {
    setSearchQuery(term);

    const dropdownSelected = Object.values(dropdownState?.dropdowns || {}).some(
      (dropdown) => dropdown?.selected?.length > 0
    );
    setproposalsDatastatus(null);
    setEnableClearAll(term !== "" || dropdownSelected);
  };

  const handleSorting = (sorting) => {
    setDatasorting(sorting);
  };

  const dropdownselected = Object.values(dropdownState?.dropdowns).some(
    (dropdown) => dropdown?.selected && dropdown?.selected.length > 0
  );

  useEffect(() => {
    console.log("languageschanged", languages);
    setDropdownState((prev) => {
      const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
        acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [], options: [] };
        if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
          acc[key].selectedMonthYear = [];
        }
        return acc;
      }, {});
      return { ...prev, dropdowns: clearedDropdowns };
    });
    console.log("languageschanged", dropdownState);
    const MyProposalsdata = {
      channel: dropdownState.dropdowns.CHANNEL.selected,
      proposalType: dropdownState.dropdowns.TYPE.selected,
      proposalStatus: dropdownState.dropdowns.STATUS.selected,
      applicationDate:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    paginationPageChange(1);
    fetchmyProposals(MyProposalsdata, 1);
  }, [languages]);

  return (
    <>
      <div className="My_Proposals">
        <div className="dashboard-top">
          <div className="dashboard-heading">{Globals.PRODUCER.MYPROPOSALS}</div>
          <Button
            action={() => {
              navigate(Globals.NAVPATH.CREATE_UNSOLICITED, { state: { activeHeader: "proposals" } });
            }}
            title={Globals.PRODUCER.UNSOLICITEDPROPOSAL}
            additionalStyle="unsolicited-proposal"
            id="Create_Unsolicited_Proposal"
          />
        </div>
        <div className="content-box">
          <div className="filters">
            <div className="results">
              {propsalsCount} {Globals.MYPROPOSALS.RESULTS}
            </div>
            <div className="row_spearator"></div>
            <div className="filterHeading">{Globals.PRODUCER.FILTERBY}</div>
            <CheckboxDropDown
              isOpen={activeDropdown === "CHANNEL"}
              options={dropdownState.dropdowns.CHANNEL.options}
              onToggle={() => handletog("CHANNEL")}
              onSelectAll={(selectAll, options) => handleSelectAll("CHANNEL", selectAll, options)}
              isDatePicker={false}
              onSelect={(value) => {
                handleSelect("CHANNEL", value);
              }}
              selectedValues={dropdownState.dropdowns.CHANNEL.selected}
              selectedItems={dropdownState.dropdowns.CHANNEL.selectedText}
              title={Globals.FILTER.CHANNEL}
              dropdownRef={(el) => (dropdownRefs.current["Channel"] = el)}
            />
            <CheckboxDropDown
              isOpen={activeDropdown === "TYPE"}
              options={dropdownState.dropdowns.TYPE.options}
              onToggle={() => handletog("TYPE")}
              onSelectAll={(selectAll, options) => handleSelectAll("TYPE", selectAll, options)}
              onSelect={(value) => {
                handleSelect("TYPE", value);
              }}
              isDatePicker={false}
              selectedValues={dropdownState.dropdowns.TYPE.selected}
              selectedItems={dropdownState.dropdowns.TYPE.selectedText}
              title={Globals.FILTER.TYPE}
              dropdownRef={(el) => (dropdownRefs.current["Type"] = el)}
            />
            <CheckboxDropDown
              isOpen={activeDropdown === "DATE"}
              options={dropdownState.dropdowns.DATE.options}
              onToggle={() => handletog("DATE")}
              onSelectAll={(selectAll) => handleSelectAll("DATE", selectAll)}
              onSelect={(value) => handleSelect("DATE", value)}
              title={Globals.FILTER.DATE}
              isDatePicker={true}
              selectedValues={dropdownState.dropdowns.DATE.selected}
              selectedMonthYear={dropdownState.dropdowns.DATE.selectedMonthYear}
              selectedMonthYearText={dropdownState.dropdowns.DATE.selectedText}
              dropdownRef={(el) => (dropdownRefs.current["Date"] = el)}
              onDateChange={(date) => handleDateChange("DATE", date)}
            />
            <CheckboxDropDown
              isOpen={activeDropdown === "STATUS"}
              options={dropdownState.dropdowns.STATUS.options}
              onToggle={() => handletog("STATUS")}
              onSelectAll={(selectAll, options) => handleSelectAll("STATUS", selectAll, options)}
              onSelect={(value) => {
                handleSelect("STATUS", value);
              }}
              isDatePicker={false}
              selectedValues={dropdownState.dropdowns.STATUS.selected}
              title={Globals.FILTER.STATUS}
              dropdownRef={(el) => (dropdownRefs.current["Status"] = el)}
              selectedItems={dropdownState.dropdowns.STATUS.selectedText}
            />

            <div
              className={enableClearAll ? "clear clearAllEnable" : "clear"}
              onClick={() => handleClearAll()}
            >
              {Globals.PRODUCER.CLEARALL}
            </div>
            <div className="search">
              <Search onSearch={handleSearch} searchedFor={searchQuery} />
            </div>
          </div>

          <div className="Table_data">
            {loadingState ?
              <Loader height={50} width={50} component={"Myproposals"} /> :
              proposalsData && proposalsData.length > 0 ? (
                <Table data={proposalsData} onSort={handleSorting} onRowClick={handleRowClick} navigate={navigate} onDelete={deleteUnsolicitedProposal} onSolictedDelete={deleteSolicitedProposal} form={"myProposals"} sortKey={dataSorting} key={languages} />
              ) : proposalsDatastatus && proposalsDatastatus.length > 0 ? (
                <div className="no-data">
                  <NoResultsComponent
                    data={{
                      message:
                        dropdownselected || (searchQuery && searchQuery.length > 0)
                          ? Globals.NO_RESULTS_MESSAGE
                          : Globals.NO_DATA_WITHOUTFILTER,
                      img:
                        dropdownselected || (searchQuery && searchQuery.length > 0)
                          ? FallBackLabel.NO_RESULTS_IMG
                          : FallBackLabel.NO_DATA_FOUND_IMG,
                      submessage:
                        dropdownselected || (searchQuery && searchQuery.length > 0)
                          ? Globals.NO_RESULTS_SUBMESSAGE
                          : "",
                    }}
                  />
                </div>
              ) : (
                <Loader height={50} width={50} component={"Myproposals"} />
              )}
          </div>
          <div className="pagination-container">
            {proposalsData && proposalsData.length > 0 ? (
              <Pagination
                totalPages={Math.ceil(propsalsCount / Globals.MAX_COUNT.MY_PROPOSALS_COUNT)}
                currentPage={currentPage}
                onPageChange={onPageChange}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      {/* <RenderPopup /> */}
      <RenderDeletePopup />
      {successToast.status && <Toast status="success" onClose={() => { setSuccessToast(false); }} title={successToast.title} />}
      {deletePopup?.success && <Toast status="info" title={deletePopup?.title} onClose={() => { setDeletePopup({ open: false, success: true }); }} />}
    </>
  );
};

export default MyProposals;
